import ReactCodeMirror from '@uiw/react-codemirror';
import { EditorView } from '@codemirror/view';
import { json } from '@codemirror/lang-json';
import { markdown } from '@codemirror/lang-markdown';
import { languages } from '@codemirror/language-data';
import { githubLight } from '@uiw/codemirror-theme-github';
import { useStyles, GlobalStyle } from './styles';

const formatValue = (v: string) => {
  if (!v) return '';
  try {
    const obj = JSON.parse(v);
    return JSON.stringify(obj, null, 2);
  } catch (error) {
    return v;
  }
};

export interface JsonViewProps {
  value: string;
  lineNumbers?: boolean;
  height?: string;
}

const JsonView: React.FC<JsonViewProps> = ({ value, height, lineNumbers = true }) => {
  const styles = useStyles();

  return (
    <>
      <ReactCodeMirror
        lang="json"
        readOnly
        className={styles.view}
        theme={githubLight}
        value={formatValue(value)}
        height={height || '160px'}
        extensions={[
          json(),
          EditorView.lineWrapping,
          markdown({
            codeLanguages: languages,
          }),
        ]}
        basicSetup={{
          lineNumbers,
        }}
      />
      <GlobalStyle />
    </>
  );
};

export default JsonView;
